import footerArtwork from '../../../assets/images/footer_artwork.svg';
import footerLogo from '../../../assets/images/logo_white.svg';
import socialFacebook from '../../../assets/images/social/facebook-circle-fill.svg';
import socialLinkedIn from '../../../assets/images/social/linkedin-box-fill.svg';
import socialG2 from '../../../assets/images/social/social-g2.svg';
import socialTwitter from '../../../assets/images/social/twitter-x-line.svg';
import socialYouTube from '../../../assets/images/social/youtube-fill.svg';

import type { FooterData, FooterMenuSection, FooterSocialItem } from './types';

export const defaultFooterSocials: FooterSocialItem[] = [
  {
    id: 'default-g2',
    label: 'G2',
    url: '#',
    target: '_blank',
    icon: {
      url: socialG2,
      width: 40,
      height: 40,
      alt: 'G2 icon',
    },
  },
  {
    id: 'default-x',
    label: 'X / Twitter',
    url: '#',
    target: '_blank',
    icon: {
      url: socialTwitter,
      width: 40,
      height: 40,
      alt: 'Twitter icon',
    },
  },
  {
    id: 'default-facebook',
    label: 'Facebook',
    url: '#',
    target: '_blank',
    icon: {
      url: socialFacebook,
      width: 40,
      height: 40,
      alt: 'Facebook icon',
    },
  },
  {
    id: 'default-linkedin',
    label: 'LinkedIn',
    url: '#',
    target: '_blank',
    icon: {
      url: socialLinkedIn,
      width: 40,
      height: 40,
      alt: 'LinkedIn icon',
    },
  },
  {
    id: 'default-youtube',
    label: 'YouTube',
    url: '#',
    target: '_blank',
    icon: {
      url: socialYouTube,
      width: 40,
      height: 40,
      alt: 'YouTube icon',
    },
  },
];

export const defaultFooterMenuSections: FooterMenuSection[] = [
  {
    id: 'default-legal',
    title: 'Legal',
    items: [
      { id: 'default-privacy', label: 'Privacy Policy', url: '#', target: '_self' },
      { id: 'default-terms', label: 'Terms of Service', url: '#', target: '_self' },
      { id: 'default-accessibility', label: 'Accessibility', url: '#', target: '_self' },
    ],
  },
  {
    id: 'default-capabilities',
    title: 'Capabilities',
    items: [
      { id: 'default-knowledge-base', label: 'Knowledge Base', url: '#', target: '_self' },
      { id: 'default-governance', label: 'Intranet Governance', url: '#', target: '_self' },
      { id: 'default-frontline', label: 'Frontline App', url: '#', target: '_self' },
      { id: 'default-onboarding', label: 'Onboarding', url: '#', target: '_self' },
      { id: 'default-enps', label: 'ENPS', url: '#', target: '_self' },
      { id: 'default-multi-language', label: 'Multi-Language Comms', url: '#', target: '_self' },
      { id: 'default-personalization', label: 'Personalization', url: '#', target: '_self' },
      { id: 'default-recognition', label: 'Recognition', url: '#', target: '_self' },
      { id: 'default-email', label: 'Email', url: '#', target: '_self' },
      { id: 'default-listening', label: 'Listening', url: '#', target: '_self' },
      { id: 'default-change', label: 'Change Management', url: '#', target: '_self' },
      {
        id: 'default-accessibility-capabilities',
        label: 'Accessibility',
        url: '#',
        target: '_self',
      },
    ],
  },
  {
    id: 'default-company',
    title: 'Company',
    items: [
      { id: 'default-about', label: 'About Interact', url: '#', target: '_self' },
      { id: 'default-news', label: 'News', url: '#', target: '_self' },
      { id: 'default-privacy-security', label: 'Privacy & Security', url: '#', target: '_self' },
      { id: 'default-careers', label: 'Careers', url: '#', target: '_self' },
      { id: 'default-contact', label: 'Contact Us', url: '#', target: '_self' },
    ],
  },
  {
    id: 'default-comparisons',
    title: 'Comparisons',
    items: [
      {
        id: 'default-v-sharepoint',
        label: 'Interact vs. SharePoint & Viva',
        url: '#',
        target: '_self',
      },
      { id: 'default-v-unily', label: 'Interact vs. Unily', url: '#', target: '_self' },
      { id: 'default-v-simpplr', label: 'Interact vs. Simpplr', url: '#', target: '_self' },
      { id: 'default-v-staffbase', label: 'Interact vs. Staffbase', url: '#', target: '_self' },
    ],
  },
];

const currentYear = new Date().getFullYear();

export const defaultFooterData: FooterData = {
  brand: {
    name: 'Interact',
    url: '/',
    logo: {
      url: footerLogo,
      width: 146,
      height: 30,
      alt: 'Interact logo',
    },
  },
  socials: defaultFooterSocials,
  menu: {
    sections: defaultFooterMenuSections,
  },
  artwork: {
    url: footerArtwork,
    width: 480,
    height: 480,
    alt: 'Geometric line artwork',
  },
  copyright: `© ${currentYear} Interact. All rights reserved.`,
};
